import { mapSupportDescription } from "@/app/common-utils/question/map-support-description";

import {
  CruisePageContent,
  GroupedCruiseMagnoliaDataType,
} from "../types/cruise.type";

export function groupedCruiseMagnoliaData(magnoliaData: CruisePageContent) {
  const magnoliaDataObj = magnoliaData.overlayArea[0];

  const userHeaderSection =
    magnoliaDataObj.assistantDescription?.[0]?.userHeaderSection;

  const filteredAssistantBodySection = userHeaderSection
    ? Object.fromEntries(Object.entries(userHeaderSection).slice(1))
    : undefined;

  const groupedData: GroupedCruiseMagnoliaDataType = {
    1: {
      headerText: magnoliaDataObj.questionText,
      descriptionSection: {
        title: magnoliaDataObj.answerOneDescription?.[0]?.title ?? "",
        body:
          mapSupportDescription(
            magnoliaDataObj.answerOneDescription?.[0]?.questionBody
          ) ?? "",
        isLoadMoreButton:
          magnoliaDataObj.answerOneLoadMoreButtonText !== undefined &&
          magnoliaDataObj.answerOneLoadMoreButtonText !== "",
        loadMoreButtonText: magnoliaDataObj.answerOneLoadMoreButtonText ?? "",
        drawerData: magnoliaDataObj.answerOneSupportDrawer ?? {},
      },
    },

    2: {
      headerText: magnoliaDataObj.questionText ?? "",
      descriptionSection: {
        title: magnoliaDataObj.answerTwoDescription?.[0]?.title ?? "",
        body:
          mapSupportDescription(
            magnoliaDataObj.answerTwoDescription?.[0]?.questionBody
          ) ?? "",
        isLoadMoreButton:
          magnoliaDataObj.answerTwoLoadMoreButtonText !== undefined &&
          magnoliaDataObj.answerTwoLoadMoreButtonText !== "",
        loadMoreButtonText: magnoliaDataObj.answerTwoLoadMoreButtonText ?? "",
        drawerData: magnoliaDataObj.answerTwoSupportDrawer ?? {},
      },
    },
    0: {
      headerText: magnoliaDataObj.questionText ?? "",
      descriptionSection: {
        title:
          magnoliaDataObj.assistantDescription?.[0]?.userHeaderSection[0]
            .text ?? "",
        body: mapSupportDescription(filteredAssistantBodySection) ?? "",
        isLoadMoreButton:
          magnoliaDataObj.defaultLoadMoreButtonText !== undefined &&
          magnoliaDataObj.defaultLoadMoreButtonText !== "",
        loadMoreButtonText: magnoliaDataObj.defaultLoadMoreButtonText ?? "",
        drawerData: magnoliaDataObj.defaultSupportDrawer ?? {},
      },
    },
  } as const;
  return groupedData;
}

export function getSingleOptionItem(
  id: 0 | 1 | 2,
  selectedAnswer: 0 | 1 | 2,
  t: (key: string, fallback?: string) => string
) {
  const optionMap = {
    0: { labelValue: "Default", isSelected: selectedAnswer === 0 },
    1: {
      labelValue: t("button_group_yes", "Yes"),
      isSelected: selectedAnswer === 1,
    },
    2: {
      labelValue: t("button_group_no", "No"),
      isSelected: selectedAnswer === 2,
    },
  };
  return { id, ...optionMap[id] };
}

export type AvailbleOptionsType = "YES" | "NO";
